import Common from '../common/CommonNctv';
import DataManager from './DataManager';

import MoviePlayer from './moviePlayer/App';
import MoviePlayerB from './movieTypeB/MoviePlayerB';
import SecTopBanner from './SecTopBanner';
import SecLive from './SecLive';
import SecTop from './SecTop';
import SecAttack from './SecAttack';
import SecRecent from './SecRecent';
import SecOfficial from './SecOfficial';
import SecEsports from './SecEsports';
import SecOst from './SecOst';
import SecNotice from './SecNotice';
import SecTheme from './SecTheme';
import Util from '../common/Util.js';

export default class App {
    constructor(_option){
        this.com = Common.instance;
        this.com.init(_option);
        this.dataM = new DataManager(_option);
        this.dataM.data.moviePlayer = window.moviePlayerData;

        if(_option.recommendArea.showType==='a'){
            this.moviePlayer = new MoviePlayer( this.dataM, _option.recommendArea );
        }else{
            this.moviePlayer = new MoviePlayerB( '#container section.main-movie .main-movie-centertype', this.dataM, _option.recommendArea );
        }
        this.topBanner = new SecTopBanner('#container section.banner',  this.dataM, _option.topBannerArea );
        this.liveSL = new SecLive('#contents section.main-live',  this.dataM, _option.liveArea );
        this.topSL = new SecTop('#contents section.main-top',  this.dataM, _option.popularArea );
        this.attackSL = new SecAttack('#contents section.main-attack', this.dataM, _option.attackArea );
        this.recentSL = new SecRecent('#contents section.main-recent',  this.dataM, _option.recentArea );
        this.officialSL = new SecOfficial('#contents section.main-official[data-channel="official"]',  this.dataM, _option.officialArea );
        this.esportsSL = new SecEsports('#contents section.main-official[data-channel="esports"]',  this.dataM, _option.esportsArea );
        this.ostSL = new SecOst('#contents section.main-official[data-channel="ost"]',  this.dataM, _option.ostArea );
        //this.secNotice = new SecNotice('#contents section.main-notice',  this.dataM);
        this.themeSL = new SecTheme('#contents .main-theme',  this.dataM, _option.theme );


        Promise.all( [this.dataM.loadFullData(), this.dataM.loadManualData()/*, this.dataM.loadNoticeData()*/] ).then(
            (_d) => {
                this.init();
                this.addEvents();
            },
            (_e) => console.log('loadData err', _e)
        );
    } 
    
    init(){
        this.moviePlayer.init();
        this.topBanner.init();
        this.liveSL.init();
        this.themeSL.init();
        this.topSL.init();
        this.attackSL.init();
        this.recentSL.init();
        this.officialSL.init();
        this.esportsSL.init();
        this.ostSL.init();
        //this.secNotice.init();
    }

    addEvents(){
        this.moviePlayer.addEvents();
        this.topBanner.addEvents();
        this.liveSL.addEvents();
        this.topSL.addEvents();
        this.attackSL.addEvents();
        this.recentSL.addEvents();
        this.officialSL.addEvents();
        this.esportsSL.addEvents();
        this.ostSL.addEvents();
        //this.secNotice.addEvents();
    }
    
} // end of class

Util.namespace('nc.nctv.mainIndex');
nc.nctv.mainIndex = App;